import {createStore, applyMiddleware, compose} from 'redux';
import thunkMiddleware from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';
import reducers from '../reducers';

let store;

export default function create(initialState) {
    store = createStore(
        reducers,
        initialState,
        compose(
            applyMiddleware(
                thunkMiddleware,
                promiseMiddleware()
            ),
            window.devToolsExtension ? window.devToolsExtension() : f => { return f; }
        )
    );

    if (module.hot) {
        module.hot.accept('../reducers', () => {
            const nextRootReducer = require('../reducers');
            store.replaceReducer(nextRootReducer);
        });
    }

    return store;
}

export const getStore = () => {
    return store;
};



// WEBPACK FOOTER //
// ./widget/src/js/store/index.js